import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
import { ErrorHandlerService } from '../../services';
var InviteAttendeesComponent = /** @class */ (function () {
    function InviteAttendeesComponent(data, dashboardService, errorHandlerService, router, route) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.specifyuser = false;
        this.userToresults = [];
        this.usersTo = [];
        this.invitedata = {};
        this.messageto = [];
        this.msgTitle = "";
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.msgContent = "";
        this.popUp = false;
        this.subscriptions = [];
        this.id = 0;
    }
    InviteAttendeesComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    InviteAttendeesComponent.prototype.editDisplayInline = function (edit) {
        if (edit) {
            return "inline-block";
        }
        else {
            return "none";
        }
    };
    InviteAttendeesComponent.prototype.handleChange1 = function (evt) {
        var target = evt.target;
        if (target.checked) {
            this.specifyuser = false;
        }
    };
    InviteAttendeesComponent.prototype.handleChange2 = function (evt) {
        var target = evt.target;
        if (target.checked) {
            this.specifyuser = true;
        }
    };
    InviteAttendeesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.route.params.subscribe(function (params) {
            _this.id = params['id'];
            console.log(_this.id);
        });
    };
    InviteAttendeesComponent.prototype.submit = function () {
        var _this = this;
        var arrTo = [];
        this.messageto.forEach(function (element) {
            arrTo.push(element.emailId);
        });
        this.invitedata.emailIds = arrTo;
        this.invitedata.courseId = this.id;
        this.invitedata.subject = "Course Invite";
        this.invitedata.isInviteAttendeeInMyNetowrk = !this.specifyuser;
        this.invitedata.url = process.env.HOST_URL + "?accessPage=public/viewsession?sessionId=" + this.id;
        var s1 = this.dashboardService.courseInvite(this.invitedata).subscribe(function (data) {
            console.log(data);
            _this.msgTitle = "Success";
            _this.msgContent = "Invitation Sent!!";
            _this.popUp = true;
            _this.messageto = [];
            _this.invitedata = {};
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    InviteAttendeesComponent.prototype.searchusers = function (event) {
        var _this = this;
        var s2 = this.dashboardService.userTo(event.query).subscribe(function (data) {
            console.log(data);
            _this.usersTo = data;
            _this.userToresults = _this.usersTo.map(function (user) {
                return { username: user.content,
                    emailId: user.entityId
                };
            });
            console.log(_this.userToresults);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    InviteAttendeesComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    InviteAttendeesComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    InviteAttendeesComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return InviteAttendeesComponent;
}());
export { InviteAttendeesComponent };
//# sourceMappingURL=inviteattendees.component.js.map